import {createWebHistory, createRouter} from "vue-router";
import store from "@/store";
import {getBaseUrl, resolvePath} from "./helpers";

const routes = [
    {
        path: "/",
        name: "Login",
        meta: {layout: 'layout-auth'},
        component: () => import('@/page/SSOLogin.vue'),
    },
    {
        path: "/login",
        name: "LoginForm",
        meta: {layout: 'layout-auth'},
        component: () => import('@/page/Login.vue'),
    },
    {
        path: "/forget-password",
        name: "ForgetPassword",
        meta: {layout: 'layout-auth'},
        component: () => import('@/page/ForgetPassword.vue'),
    },
    {
        path: "/test",
        component: () => import('@/page/Test.vue'),
    },
    {
        path: "/dashboard",
        name: "dashboard",
        meta: {layout: 'layout-dashboard'},
        component: () => import('@/page/Dashboard.vue'),
    },
    {
        path: "/user-info",
        name: "user-info",
        meta: {layout: 'layout-dashboard'},
        component: () => import('@/page/UserInfo.vue'),
    },
    {
        path: "/operator-teams",
        name: "operator-teams",
        meta: {layout: 'layout-dashboard'},
        component: () => import('@/page/TeamManagement.vue'),
    },
    {
        path: "/workflow-teams",
        name: "workflow-teams",
        meta: {layout: 'layout-dashboard'},
        component: () => import('@/page/WorkflowTeams.vue'),
    },
    {
        path: "/system-setup",
        name: "system-setup",
        meta: {layout: 'layout-dashboard'},
        component: () => import('@/page/SystemSetup.vue'),
    },
    {
        path: "/terminal-setup",
        name: "terminal-setup",
        meta: {layout: 'layout-dashboard'},
        component: () => import('@/page/TerminalSetup.vue'),
    },
    {
        path: "/shift-management",
        name: "shift-management",
        meta: {layout: 'layout-dashboard'},
        component: () => import('@/page/ShiftManagement.vue'),
    },
    {
        path: "/operator-dashboard",
        name: "operator_dashboard",
        meta: {layout: 'layout-operator-dashboard', skipPermissionCheck: true},
        component: () => import('@/page/OperatorDashboard.vue'),
    },
    {
        path: "/user-profile",
        name: "user-profile",
        meta: {layout: 'layout-dashboard', skipPermissionCheck: true},
        component: () => import('@/page/UserProfile.vue'),
    },
    {
        path: "/change-password",
        name: "change-password",
        meta: {layout: 'layout-dashboard', skipPermissionCheck: true},
        component: () => import('@/page/ChangePassword.vue'),
    },
    {
        path: "/call-center-view/:token",
        name: "call-center-view",
        props: true,
        meta: {layout: 'layout-default', skipPermissionCheck: true},
        component: () => import('@/page/CallCenterView.vue'),
    },
    {
        path: "/call_log_report",
        name: "call_log_report",
        meta: {layout: 'layout-dashboard'},
        component: () => import('@/page/reports/CallLogReport.vue'),
    },
    {
        path: "/l-complaint-workflows",
        name: "l-complaint-workflows",
        meta: {layout: 'layout-dashboard'},
        component: () => import('@/page/ComplaintWorkflows.vue'),
    },
    {
        path: "/call-center-dashboard/:user_id",
        name: "call-center-dashboard",
        props: true,
        meta: {layout: 'layout-default', skipPermissionCheck: true},
        component: () => import('@/page/CallCenterDashboard.vue'),
    },
    {
        path: "/complaints",
        name: "complaints",
        meta: {layout: 'layout-dashboard'},
        component: () => import('@/page/ComplaintsPage.vue'),
    },
    {
        path: "/complain-info-report",
        name: "complainInfoReport",
        meta: {layout: 'layout-dashboard'},
        component: () => import('@/page/reports/forms/ComplainInfoReport.vue'),
    },
    {
        path: "/complain-report",
        name: "complainReport",
        meta: {skipPermissionCheck: true},
        component: () => import('@/page/reports/ComplainReport.vue'),
    },
    {
        path: "/operator-chat",
        name: "OperatorChat",
        meta: {layout: 'layout-dashboard'},
        component: () => import('@/page/OperatorChat.vue'),
    },
    {
        path: "/chat-history-report",
        name: "chatHistoryReport",
        meta: {layout: 'layout-dashboard'},
        component: () => import('@/page/reports/forms/ChatHistoryReport.vue'),
    },
    {
        path: "/chat-history-report-data",
        name: "chatHistoryReportData",
        meta: {skipPermissionCheck: true},
        component: () => import('@/page/reports/ChatHistoryReportData.vue'),
    },
    {
        path: "/chat-feedback-report",
        name: "chatFeedbackReport",
        meta: {layout: 'layout-dashboard'},
        component: () => import('@/page/reports/forms/ChatFeedbackReport.vue'),
    },
    {
        path: "/chat-feedback-report-data",
        name: "chatFeedbackReportData",
        meta: {skipPermissionCheck: true},
        component: () => import('@/page/reports/ChatFeedbackReportData.vue'),
    },
    {
        path: "/chat-details",
        name: "chatDetails",
        meta: {skipPermissionCheck: true},
        component: () => import('@/page/ChatDetails.vue'),
    },
    {
        path: "/user-chat",
        name: "UserChat",
        meta: {layout: 'default'},
        component: () => import('@/page/UserChat.vue'),
    },
    {
        path: "/operator_daily_report",
        name: "operatorDailyReport",
        meta: {layout: 'layout-dashboard'},
        component: () => import('@/page/reports/forms/OperatorDailyReport.vue'),
    },
    {
        path: "/operator-report",
        name: "operatorReport",
        meta: {skipPermissionCheck: true},
        component: () => import('@/page/reports/OperatorReport.vue'),
    },
    {
        path: "/missed_calls_report",
        name: "missedCallsReport",
        meta: {layout: 'layout-dashboard'},
        component: () => import('@/page/reports/forms/MissedCallsReport.vue'),
    },
    {
        path: "/missed-report",
        name: "missedReport",
        meta: {skipPermissionCheck: true},
        component: () => import('@/page/reports/MissedReport.vue'),
    },
    {
        path: "/daily-summary-report",
        name: "dailySummaryReport",
        meta: {layout: 'layout-dashboard'},
        component: () => import('@/page/reports/forms/DailySummaryReport.vue'),
    },
    {
        path: "/daily-sum-report",
        name: "dailySumReport",
        meta: {layout: 'default', skipPermissionCheck: true},
        component: () => import('@/page/reports/DailySumReport.vue'),
    },
    {
        path: "/complaint-detail-report/:ticket",
        name: "complaintDetailReport",
        meta: {skipPermissionCheck: true},
        component: () => import('@/page/reports/ComplaintDetailReport.vue'),
        props: true,
    },
    {
        path: "/faq",
        name: "FAQ",
        meta: {layout: 'layout-dashboard'},
        component: () => import('@/page/FAQ.vue'),
    },
    {
        path: "/enquiry",
        name: "Enquiry",
        meta: {layout: 'layout-dashboard'},
        component: () => import('@/page/EnquiryInfo.vue'),
    },
    {
        path: "/roles",
        name: "Roles",
        meta: {layout: 'layout-dashboard'},
        component: () => import('@/page/Roles.vue'),
    },
    {
        path: "/permissions",
        name: "Permissions",
        meta: {layout: 'layout-dashboard'},
        component: () => import('@/page/Permissions.vue'),
    },
    {
        path: "/menus",
        name: "UserMenus",
        meta: {layout: 'layout-dashboard'},
        component: () => import('@/page/UserMenus.vue'),
    },
    {
        path: "/:catchAll(.*)",
        name: "NotFound",
        meta: {layout: 'default'},
        component: () => import('@/page/NotFound.vue'),
    },
    {
        path: "/query-categories",
        name: "query-categories",
        meta: {layout: 'layout-dashboard'},
        component: () => import('@/page/QueryCategory.vue'),
    },
    {
        path: "/query-types",
        name: "query-types",
        meta: {layout: 'layout-dashboard'},
        component: () => import('@/page/QueryTypes.vue'),
    },
    {
        path: "/recycle-bin",
        name: "recycle-bin",
        meta: {layout: 'layout-dashboard'},
        component: () => import('@/page/RecycleBin.vue'),
    },
    {
        path: "/potential-customers",
        name: "potential-customers",
        meta: {layout: 'layout-dashboard'},
        component: () => import('@/page/PotentialCustomers.vue'),
    },
    {
        path: "/option-settings",
        name: "option-settings",
        meta: {layout: 'layout-dashboard'},
        component: () => import('@/page/OptionSettings.vue'),
    },
    {
        path: "/faq-categories",
        name: "faq-categories",
        meta: {layout: 'layout-dashboard'},
        component: () => import('@/page/FaqCategories.vue'),
    },
    {
        path: "/alert-templates",
        name: "alert-templates",
        meta: {layout: 'layout-dashboard'},
        component: () => import('@/page/AlertTemplates.vue'),
    },
    {
        path: "/activity-logs",
        name: "activity-logs",
        meta: {layout: 'layout-dashboard'},
        component: () => import('@/page/ActivityLogs.vue'),
    },
    {
        path: "/search",
        name: "search",
        meta: {layout: 'layout-dashboard', skipPermissionCheck: true},
        component: () => import('@/page/SearchResults.vue'),
    },
    {
        path: "/reset-password",
        name: "reset-password",
        meta: {layout: 'layout-auth'},
        component: () => import('@/page/ResetPassword.vue'),
    },
    {
        path: "/oauth2/login/code/:provider",
        name: "oauth2-callback",
        meta: {layout: 'layout-auth'},
        component: () => import('@/page/OAuth2Callback.vue'),
    },
    {
        path: "/bulk-notifications",
        name: "bulk-notifications",
        meta: {layout: 'layout-dashboard'},
        component: () => import('@/page/BulkNotifications.vue'),
    },
    {
        path: "/translations",
        name: "translations",
        meta: {layout: 'layout-dashboard'},
        component: () => import('@/page/TranslationsPage.vue'),
    },
    {
        path: "/blacklisted-callers",
        name: "blacklisted-callers",
        meta: {layout: 'layout-dashboard'},
        component: () => import('@/page/BlacklistedCallers.vue'),
    },
];

const router = createRouter({
    history: createWebHistory(getBaseUrl()),
    routes,
    linkActiveClass: "active-auto", // active class for non-exact links.
    linkExactActiveClass: "active-auto" // active class for *exact* links.
});

router.beforeEach((to, from, next) => {
    if (to.query.token) {
        next();
        return;
    }

    const publicPages = ['/', '/login', '/test', '/forget-password', '/user-chat', '/reset-password', '/oauth2/login/code/keycloak'];
    const authRequired = !publicPages.includes(to.path);
    const user = JSON.parse(localStorage.getItem('user'));

    if (authRequired && !isLoggedIn(user)) {
        next(resolvePath('/'));
    } else if (authRequired && to.name === 'LoginForm') {
        next();
    } else {
        if (isLoggedIn(user) && 5 == user.user.user_type_id && to.path !== '/user-chat') {
            next(resolvePath('/user-chat'));
        } else if (hasMenuPermission(to, publicPages, user)) {
            next();
        } else {
            if (to.path !== '/dashboard') {
                if (to.path !== '/' && to.path !== '/dashboard') {
                    store.commit('setMessage', 'You cannot access this route!');
                }
                next(resolvePath('/dashboard'));
            } else {
                if (isLoggedIn(user)) {
                    next();
                } else {
                    next(resolvePath('/'));
                }
            }
        }
    }
});

function isLoggedIn(user) {
    return !!(user && user.token);
}

function hasMenuPermission(to, publicPages, user) {
    if (to.name === 'oauth2-callback') {
        return true;
    }
    if (isLoggedIn(user) && 5 != user.user.user_type_id && publicPages.includes(to.path)) {
        return false;
    }
    // if(isLoggedIn(user) && to.path === '/') {
    //     return false
    // }
    if (!to.meta.skipPermissionCheck && !publicPages.includes(to.path)) {
        return user && user.menus && user.menus.some(item => item.menu_url === to.path);
    }
    return true;
}

export default router;